import { Button } from '@shared/components';

import { type AlternativeForeignerRegistrationModalLogicState } from './alternative-foreigner-registration-modal-logic';

interface AlternativeForeignerRegistrationModalLogicActionProps {
  state: AlternativeForeignerRegistrationModalLogicState;
  loading: boolean;
  cameraReady: boolean;
  onClose: () => void;
  onSubmit: () => void;
  captureImage: () => void;
  onRetryCamera: () => void;
  onConfirmImage: () => void;
}

export function AlternativeForeignerRegistrationModalLogicAction(
  props: Readonly<AlternativeForeignerRegistrationModalLogicActionProps>,
) {
  const {
    state,
    loading: isLoading,
    onClose,
    onSubmit,
    captureImage,
    cameraReady: isCameraReady,
    onRetryCamera,
    onConfirmImage,
  } = props;

  switch (state) {
    case 'form':
      return (
        <>
          <Button size='large' variant='outlined' color='secondary' onClick={onClose}>
            ยกเลิก
          </Button>
          <Button size='large' onClick={onSubmit} loading={isLoading} disabled={isLoading}>
            อนุมัติ
          </Button>
        </>
      );
    case 'image-capturing':
      return (
        <Button size='large' onClick={captureImage} disabled={!isCameraReady}>
          ถ่ายภาพ
        </Button>
      );
    case 'image-confirmation':
      return (
        <>
          <Button size='large' variant='outlined' color='secondary' onClick={onRetryCamera}>
            ถ่ายใหม่
          </Button>
          <Button size='large' onClick={onConfirmImage}>
            ยืนยัน
          </Button>
        </>
      );
    case 'error':
      return (
        <Button size='large' variant='outlined' color='secondary' onClick={onClose}>
          ปิด
        </Button>
      );
    default:
      return null;
  }
}
